import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { css, StyleSheet } from 'aphrodite';
import Icon from 'react-svg-ikon';

import { TSS_RED, TSS_BLUE, TSS_GREEN } from 'tss-core-lib-common';
import { IMG_ICON_WARNING_O_LARGE, IMG_ICON_ERROR_TRIANGLE, IMG_ICON_SUCCESS_O } from '../img';

var styles = void 0;

var Flash = function Flash(_ref) {
  var message = _ref.message,
      messageKey = _ref.messageKey,
      error = _ref.error,
      success = _ref.success,
      info = _ref.info;

  var color = TSS_GREEN();
  var icon = IMG_ICON_SUCCESS_O;

  if (error) {
    color = TSS_RED();
    icon = IMG_ICON_ERROR_TRIANGLE;
  } else if (info) {
    color = TSS_BLUE();
    icon = IMG_ICON_WARNING_O_LARGE;
  }
  return React.createElement(
    'div',
    { className: css(styles.outer) },
    React.createElement(
      'div',
      { className: css(styles.container, success && styles.success, info && styles.info, error && styles.error) },
      React.createElement(Icon, { src: icon, stroke: color, className: css(styles.icon) }),
      React.createElement(
        'div',
        { className: css(styles.content) },
        message || null,
        messageKey ? React.createElement(FormattedMessage, { id: messageKey }) : null
      )
    )
  );
};

Flash.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  info: PropTypes.bool,
  message: PropTypes.string,
  messageKey: PropTypes.string
};

Flash.defaultProps = {
  error: false,
  success: true,
  info: false,
  message: null,
  messageKey: null
};

styles = StyleSheet.create({
  outer: {
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.3)',
    border: 0,
    borderRadius: 2
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '1.2rem',
    fontSize: '1.4rem',
    minWidth: '25vw',
    maxWidth: '50vw',
    fontWeight: 500
  },

  info: {
    backgroundColor: TSS_BLUE(0.4)
  },

  error: {
    backgroundColor: TSS_RED(0.4)
  },

  success: {
    backgroundColor: TSS_GREEN(0.4)
  },

  icon: {
    width: '2.4rem',
    height: '2.4rem'
  },

  content: {
    flex: '1 1 100%',
    margin: '0 0 0 1.6rem'
  }
});

export default Flash;